import { createSlice } from "@reduxjs/toolkit";

const consumerEngagementSlice = createSlice({
  name: "consumerEngagement",
  initialState: {
    // Disbursement
    disbursements: [],
    disbursementTotal: 0,
    providers: [],
    currencies: [],
    companyDropdown: [],
    companyDropdownTotal: 0,
    companyDropdownHasMore: true,
    disbursementLoading: false,

    // Transaction Reports
    reports: [],
    reportsTotal: 0,
    selectedReport: null,
    reportsLoading: false,

    // Notification Settings
    notificationEnabled: false,
    notificationEmails: [],

    error: null,
  },
  reducers: {
    setDisbursements(state, action) {
      state.disbursements = action.payload.data || [];
      state.disbursementTotal = action.payload.total || 0;
      state.disbursementLoading = false;
    },
    setDisbursementLoading(state, action) {
      state.disbursementLoading = action.payload;
      if (action.payload) state.error = null;
    },
    setProviders(state, action) {
      state.providers = action.payload;
    },
    setCurrencies(state, action) {
      state.currencies = action.payload;
    },
    setCompanyDropdown(state, action) {
      const { data, total, append } = action.payload;
      if (append) {
        state.companyDropdown = [...state.companyDropdown, ...data];
      } else {
        state.companyDropdown = data;
      }
      state.companyDropdownTotal = total;
      state.companyDropdownHasMore = state.companyDropdown.length < total;
    },
    resetCompanyDropdown(state) {
      state.companyDropdown = [];
      state.companyDropdownTotal = 0;
      state.companyDropdownHasMore = true;
    },
    setReports(state, action) {
      state.reports = action.payload.data || [];
      state.reportsTotal = action.payload.total || 0;
      state.reportsLoading = false;
    },
    setReportsLoading(state, action) {
      state.reportsLoading = action.payload;
      if (action.payload) state.error = null;
    },
    setSelectedReport(state, action) {
      state.selectedReport = action.payload;
    },
    resetSelectedReport(state) {
      state.selectedReport = null;
    },
    setNotificationSettings(state, action) {
      state.notificationEnabled = action.payload.enabled;
      state.notificationEmails = action.payload.emails || [];
    },
    setError(state, action) {
      state.error = action.payload;
    },
  },
});

export const {
  setDisbursements,
  setDisbursementLoading,
  setProviders,
  setCurrencies,
  setCompanyDropdown,
  resetCompanyDropdown,
  setReports,
  setReportsLoading,
  setSelectedReport,
  resetSelectedReport,
  setNotificationSettings,
  setError,
} = consumerEngagementSlice.actions;
export default consumerEngagementSlice.reducer;
